import axios from 'axios';

// Get the API base URL from environment variables
// In development, this will be undefined and we'll use the Vite proxy
// In production, this will be set by Cloudflare Workers environment variables
const API_BASE_URL = import.meta.env.VITE_API_URL;

// Create axios instance with base configuration
const apiClient = axios.create({
  baseURL: API_BASE_URL || '/api', // Fallback to '/api' for development proxy
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.defaults.withCredentials = true;

// Add request interceptor for logging (optional)
if (apiClient.interceptors) {
  apiClient.interceptors.request.use(
    config => {
      console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
      return config;
    },
    error => {
      console.error('API Request Error:', error);
      return Promise.reject(error);
    },
  );

  // Add response interceptor for error handling
  apiClient.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      console.error('API Response Error:', error.response?.data || error.message);
      return Promise.reject(error);
    },
  );
}

export default apiClient;
